/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type UpdateMemberRoleRequestRole = typeof UpdateMemberRoleRequestRole[keyof typeof UpdateMemberRoleRequestRole];


export const UpdateMemberRoleRequestRole = {
  admin: 'admin',
  member: 'member',
} as const;
